import React from 'react'
import { useMutation } from '@apollo/client'
import { CREATE_GOAL_GROUP } from 'Apollo/Mutations/CreateGoalGroup'
import { CreateGoalGroupInput, GoalCategory } from 'Generated/graphql-types'
import { Text } from './FunderSharedGoals.styled'
import { GoalGroupCreationContainer } from './GoalGroupCreation.styled'
import { GoalGroupInputs } from '../../FunderDashboard/FunderGoals/GoalGroupModal/GoalGroupInputs'

type GoalGroupCreationProps = {
  popError: (message: string) => void
  popSuccess: (message: string) => void
}

export const GoalGroupCreation = ({
  popError,
  popSuccess,
}: GoalGroupCreationProps) => {
  const [createGoalGroup, { loading }] = useMutation(CREATE_GOAL_GROUP)

  const areGoalGroupInputsValid = ({
    category,
    target,
    title,
  }: CreateGoalGroupInput) => {
    if (target && Number.isNaN(Number(target))) return false
    if (category === GoalCategory.None) return false
    return !(!title || !category)
  }

  const handleCreateGoalGroup = async (
    goalGroupToCreate: CreateGoalGroupInput
  ) => {
    try {
      if (!areGoalGroupInputsValid(goalGroupToCreate)) {
        popError(
          'Please ensure all required fields are filled out and have valid data.'
        )
        return false
      }

      const { data } = await createGoalGroup({
        variables: { data: goalGroupToCreate },
      })

      if (!data || !data.createGoalGroup) {
        popError('Failed to create goal group')
        return false
      }

      const successMessage = `Goal group created successfully! GoalGroup ID: ${data.createGoalGroup.id}`
      popSuccess(successMessage)
      return true
    } catch (e) {
      popError('Failed to create goal group. Please try again.')
      return false
    }
  }

  return (
    <GoalGroupCreationContainer>
      <Text>
        Use this tool to create a goal group entry in the database. Optionally,
        you can use the ID of the created group in the next tab (Goal Creation).
      </Text>
      <GoalGroupInputs
        disableTargetFields={false}
        isLoading={loading}
        onCancelLabel='Clear All'
        onSubmit={handleCreateGoalGroup}
        onSubmitLabel='Create Goal Group'
      />
    </GoalGroupCreationContainer>
  )
}
